import { render, staticRenderFns } from "./OverlayContent.vue?vue&type=template&id=0f1dc258&"
import script from "./OverlayContent.vue?vue&type=script&lang=js&"
export * from "./OverlayContent.vue?vue&type=script&lang=js&"
import style0 from "./OverlayContent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports